import * as React from "react";
import { Carousel } from "@grandvisionhq/common";
import { BannerTooltip, Banner } from "@grandvisionhq/content";
import { compose } from "@grandvisionhq/utils";
/* empty css              */
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withBloomreachPageable } from "../../../../hocs/hocs/with-bloomreach-pageable.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
import { withEditableContent } from "../../../../hocs/hocs/with-editable-content.js";
import { useBloomreachLinks } from "../../../../hooks/hooks/use-bloomreach-links.js";
import { parseBloomreachImage } from "../../../../utils/utils/parse-bloomreach-image.js";
const CmsCarouselItem = withEditableContent(({ content }) => {
  const [link] = useBloomreachLinks(content.links);
  const image = parseBloomreachImage(content.image);
  const tooltip = content.tooltip?.showTooltip ? content.tooltip : void 0;
  if (!image) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, tooltip && /* @__PURE__ */ React.createElement(BannerTooltip, { className: "carousel__item--tooltip", tooltip }), /* @__PURE__ */ React.createElement(Banner, { image: image.original, mobileImage: image.mobile, link }));
});
const CmsCarousel = ({ content }) => {
  return /* @__PURE__ */ React.createElement(Carousel, { hasPagination: true }, content.items.map((item) => /* @__PURE__ */ React.createElement(CmsCarouselItem, { key: item.id, content: item })));
};
const CmsCarousel$1 = compose(
  withBreakpointVisibility,
  withBloomreachPageable,
  withAnchor
)(CmsCarousel);
export {
  CmsCarousel,
  CmsCarouselItem,
  CmsCarousel$1 as default
};
//# sourceMappingURL=Carousel.js.map
